import { ChangeDetectionStrategy, Component, HostBinding, inject, input } from '@angular/core';
import { RouterLinkActive } from '@angular/router';

@Component({
  selector: 'a[app-sidebar-item][routerLink]',
  standalone: true,
  imports: [],
  hostDirectives: [
    {
      directive: RouterLinkActive,
    },
  ],
  templateUrl: './sidebar-item.ui-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarItemUiComponent {
  @HostBinding('class.group') group = true;
  private readonly routerLinkActive = inject(RouterLinkActive);
  readonly isCollapsed = input<boolean>(false);
  readonly icon = input<string>('');
  readonly label = input<string>('');

  @HostBinding('class') get tailwind(): string {
    const baseClasses = this.isCollapsed()
      ? 'flex items-center justify-center py-2 rounded-md'
      : 'flex items-center px-3 py-2 rounded-md';

    const stateClasses = this.routerLinkActive.isActive ? 'bg-cyan-900 font-bold' : 'hover:bg-slate-600';

    return `${baseClasses} ${stateClasses}`;
  }
}
